module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isDialogActivarDesactivar) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeDialogActivaDesactiva()
      }
    }
  }), _c('div', {
    staticClass: "card width-350"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.formDesactiva.estadoDescripcion) + " noticia")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [
    [_c('span', {
      staticClass: "bold"
    }, [_vm._v("¿Realmente deseas " + _vm._s(_vm.formDesactiva.estadoDescripcion) + " la noticia")]), _c('strong', {
      staticClass: "bold has-text-primary"
    }, [_vm._v("   " + _vm._s(_vm.formDesactiva.titulo) + "   ")]), _c('span', [_vm._v("?")])]
  ], 2)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogActivaDesactiva()
      }
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "button card-footer-item info-box-button",
    class: {
      'is-success': _vm.formDesactiva.estadoDescripcion === 'Activar', 'is-danger': _vm.formDesactiva.estadoDescripcion === 'Desactivar', 'is-loading': _vm.isloading
    },
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.fetchActivarDesactivar()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formDesactiva.estadoDescripcion))])])])])]) : _vm._e(), (_vm.showModalAdd) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeModalAdd
    }
  }), _c('div', {
    staticClass: "card w-750"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.formulario.id ? 'Editar' : 'Nueva') + " Noticia")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Título")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formulario.titulo),
      expression: "formulario.titulo"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "placeholder": "Ingrese el título de la noticia",
      "disabled": _vm.isloading
    },
    domProps: {
      "value": (_vm.formulario.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formulario, "titulo", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "d-flex form-row margin-bottom-20"
  }, [_c('div', {
    staticClass: "flex-1 margin-right-15"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Descripción")]), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formulario.descripcion),
      expression: "formulario.descripcion"
    }],
    staticClass: "textarea is-small",
    attrs: {
      "rows": "5",
      "placeholder": "Ingrese la descripción de la noticia",
      "disabled": _vm.isloading
    },
    domProps: {
      "value": (_vm.formulario.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formulario, "descripcion", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "fecha-vencimiento"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Fecha Vencimiento")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formulario.fechaVencimiento),
      expression: "formulario.fechaVencimiento"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "date",
      "disabled": _vm.isloading
    },
    domProps: {
      "value": (_vm.formulario.fechaVencimiento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formulario, "fechaVencimiento", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Imagen de la noticia")]), _c('input', {
    ref: "inputFoto",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/jpg,image/webp"
    },
    on: {
      "change": _vm.seleccionarFoto
    }
  }), (!_vm.previewFoto) ? _c('div', {
    staticClass: "upload-image",
    on: {
      "click": _vm.abrirSelectorFoto
    }
  }, [_vm._m(0), _vm._m(1), _c('span', {
    staticClass: "upload-formats"
  }, [_vm._v("JPG, PNG o WEBP")])]) : _c('div', {
    staticClass: "image-preview-container"
  }, [_c('img', {
    staticClass: "image-preview",
    attrs: {
      "src": _vm.previewFoto,
      "alt": "Vista previa de la noticia"
    }
  }), _c('div', {
    staticClass: "image-preview-overlay"
  }, [_c('div', {
    staticClass: "preview-actions"
  }, [_c('button', {
    staticClass: "button is-small is-info",
    attrs: {
      "type": "button",
      "disabled": _vm.isloading
    },
    on: {
      "click": _vm.abrirSelectorFoto
    }
  }, [_vm._m(2), _c('span', [_vm._v("Cambiar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isloading
    },
    on: {
      "click": _vm.eliminarFoto
    }
  }, [_vm._m(3), _c('span', [_vm._v("Eliminar")])])])])])]), _c('div', {
    staticClass: "d-flex justify-content-flex-end margin-top-20px"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-small is-light",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }, [_c('span', [_vm._v("Cancelar")])])]), _c('p', {
    staticClass: "control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small is-success",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardar()
      }
    }
  }, [_vm._m(4), _c('span', [_vm._v("Guardar cambios")])])])])])])])]) : _vm._e(), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "flex d-flex jc-center fd-column"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Titulo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titulo),
      expression: "titulo"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "disabled": _vm.isloading
    },
    domProps: {
      "value": (_vm.titulo)
    },
    on: {
      "change": _vm.fetch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titulo = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "flex d-flex jc-center fd-column margin-left-10"
  }, [_c('label', {
    staticClass: "label is-small has-text-left"
  }, [_vm._v("Estado")]), _c('div', {
    staticClass: "d-flex width-100"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "select is-small d-flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.estado),
      expression: "estado"
    }],
    staticClass: "flex-1",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.estado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fetch]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Todos")]), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v("Activo")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v("Inactivo")])])])])])]), _c('div', {
    staticClass: "flex-1 d-flex justify-content-flex-end"
  }, [_c('p', {
    staticClass: "control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small is-success",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.openModalAdd()
      }
    }
  }, [_vm._m(5), _c('span', [_vm._v("Nuevo")])])]), _c('p', {
    staticClass: "control control margin-left-5"
  }, [_c('button', {
    staticClass: "button is-small is-primary",
    attrs: {
      "disabled": _vm.isloading
    },
    on: {
      "click": function($event) {
        return _vm.fetch()
      }
    }
  }, [_vm._m(6), _c('span', [_vm._v("Actualizar")])])])])])])]), _c('div', {
    staticClass: "card margin-top-5"
  }, [_c('div', {
    staticClass: "position-relative",
    attrs: {
      "id": "data-table"
    }
  }, [(_vm.lista.length === 0 && !_vm.isloading) ? _c('div', {
    staticClass: "empty-list"
  }, [_c('i', {
    staticClass: "fa fa-address-card fa-6x"
  }), _vm._m(7)]) : _vm._e(), (_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table table is-full-width is-responsive"
  }, [_vm._m(8), _c('transition-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "table-transition",
    attrs: {
      "name": "fade-smooth",
      "tag": "tbody",
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('tr', {
      key: ("index_" + (index + 1)),
      class: {
        'bd-desactivado': !item.estado
      }
    }, [_c('td', {
      staticClass: "center-vertical-align-middle cursor-pointer"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _c('td', {
      staticClass: "center-vertical-align-middle cursor-pointer"
    }, [_c('span', [_vm._v(_vm._s(item.titulo))])]), _c('td', {
      staticClass: "center-vertical-align-middle cursor-pointer"
    }, [_c('span', [_vm._v(_vm._s(item.descripcion))])]), _c('td', {
      staticClass: "center-vertical-align-middle"
    }, [_c('strong', {
      staticClass: "has-text-info"
    }, [_vm._v(_vm._s(_vm._f("formatoFechaText")(item.fechaVencimiento)))])]), _c('td', {
      staticClass: "center-vertical-align-middle"
    }, [_c('strong', {
      staticClass: "has-text-info"
    }, [_vm._v(_vm._s(item.modulo))])]), _c('td', {
      staticClass: "center-vertical-align-middle"
    }, [_c('strong', {
      staticClass: "chip tag",
      class: {
        'is-success': item.estado, 'is-danger': !item.estado
      }
    }, [_vm._v(_vm._s(item.estado ? 'Activo' : 'Inactivo'))])]), _c('td', {
      staticClass: "center-vertical-align-middle"
    }, [(item.modulo !== 'documentos_importantes') ? _c('button', {
      staticClass: "button is-small margin-left-5",
      attrs: {
        "disabled": _vm.isloading || !item.estado
      },
      on: {
        "click": function($event) {
          return _vm.editarForm(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]) : _vm._e(), (item.estado) ? _c('button', {
      staticClass: "button is-small is-danger margin-left-5",
      attrs: {
        "disabled": _vm.isloading
      },
      on: {
        "click": function($event) {
          return _vm.openDialogActivaDesactiva(item)
        }
      }
    }, [_c('span', [_vm._v("Desactivar")])]) : _c('button', {
      staticClass: "button is-small is-success margin-left-5",
      attrs: {
        "disabled": _vm.isloading
      },
      on: {
        "click": function($event) {
          return _vm.openDialogActivaDesactiva(item)
        }
      }
    }, [_c('span', [_vm._v("  Activar   ")])])])])
  }), 0)], 1) : _vm._e(), (_vm.isloading) ? _c('loading-global-sil', {
    attrs: {
      "message": 'Cargando'
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-image-icon"
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-image-text"
  }, [_c('strong', [_vm._v("Seleccionar imagen")]), _c('span', [_vm._v("Haz clic para adjuntar una fotografía")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encuentran registros para esta búsqueda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("#")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Titulo")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Descripcion")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Fecha Vencimiento")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Modulo")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Estado")]), _c('th', {
    staticClass: "center-vertical-align-middle cursor-pointer"
  }, [_vm._v("Accion")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77282e55","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Administrador_Noticias.vue
// module id = 910
// module chunks = 0